export const REPORT_KEYS = {
  GET_REPORT: 'get-report',
  GET_REPORTS: 'get-reports',
  GET_REPORT_TABLE: 'single-report-requests-table',
  CREATE_REPORT: 'get-create-request-report',
  SUITABLE: 'get-suits-ids-for-create-requests-report',
  CREATE: 'create-requests-report',
  ADD: 'add-requests-to-request-report',
}
